<template>
  <div
    class="notifications-item"
    :data-type="type"
    :data-id="log.id"
    :class="[{ notificator: log.notificator , 'notifications-item--in-modal': inModal}, log.read && 'is-read']"

  >
    <div class="date hide-mobile">
      {{ date }} ∙ {{ time }}
      <!--<div class="badge" v-if="badgeNew">{{ $t('new') }}</div>-->
      <!--<div class="title__main-tag" v-if="!large">{{ log.type.title }}</div>-->
    </div>
    <div class="user" @click="readMoreClick">

      <Avatar size="sm" class="size-auto">
        <img :src="icon" />
      </Avatar>

      <div class="title">
        <span class="notificator">
          <h6 class="notificator__title">
            {{ log.title }} <span v-if="log.notificator">({{ notifier }})</span> <div class="time">{{ time }}</div>
          </h6>
          <div class="notificator__content" v-html="getHtml(log.content)"></div>

        </span>

<!--        <template v-if="large">-->
<!--          <div class="title__main">-->
<!--            &lt;!&ndash; todo api missmatch &ndash;&gt;-->
<!--            <span v-if="log.library">{{ $t('Notification.title') }}</span>-->
<!--          </div>-->
<!--          <div class="title__sub">-->
<!--            <span class="action" v-if="log.library">{{ log.library.name }}</span>-->
<!--            <span class="action" v-if="log.notificator">{{ log.changes.content }}</span>-->
<!--          </div>-->
<!--        </template>-->
      </div>
    </div>
    <div class="mobile-time">{{ time }}</div>
    <div class="notifications-item__content" v-html="getHtml(log.content)"></div>

    <div v-if="large && log.library" class="middle">
      <span>{{ log.library.name }}</span>
      <div class="badge bg blue">PDF</div>
    </div>
    <!--<div class="about">
            {{ eventName }}
            <div class="badge bg primary">PDF</div>
        </div>-->

    <Modal :id="idLog" class="modal-notification" v-if="log.notificator" #default="{ close }">
      <h2 class="log-title">
        <span>{{ log.changes.title }}</span>
        <div class="date">{{ date }} • {{ time }}</div>
      </h2>

      <div class="pre-line" v-html="getHtml(log.changes.content)"></div>

      <button class="remove" @click.prevent="close"></button>
    </Modal>
    <div class="notifications-item__actions">
      <router-link v-if="log.type === 'event'" class="link" :to="{ name: 'Schedule' }">
        <button class="primary border">{{ $t('Notifications.view-event') }}</button>
      </router-link>
      <router-link v-if="log.type === 'library'" class="link" :to="{ name: 'Materials library' }">
        <button class="primary border">{{ $t('Notifications.view-library') }}</button>
      </router-link>
      <svg @click="handleRemove" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 5.5H15" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
        <path d="M3 5.5V12.5C3 14.1569 4.34315 15.5 6 15.5H10C11.6569 15.5 13 14.1569 13 12.5V5.5" stroke="#CCD7E6" stroke-width="2"/>
        <path d="M5 2.5H11" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </div>
  </div>
</template>

<script>
import Avatar from '@/components/user/Avatar'

import notify from '@/assets/icons/notify.svg'
import message from '@/assets/icons/message.svg'

import moment from 'moment'
import Modal from '@/components/modals/Modal'
import { mapActions, mapMutations } from 'vuex'
import SvgIcon from '@/components/ui/SvgIcon.vue'

export default {
  name: 'Notification',
  components: { SvgIcon, Modal, Avatar },
  props: {
    log: Object,
    large: Boolean,
    badgeNew: Boolean,
    inModal: Boolean,
  },
  data: () => ({
    notify,
    message,
  }),
  computed: {
    type() {
      return this.log.type.id
    },
    icon() {
      return this.log.notificator ? this.message : this.notify
    },
    idLog() {
      return `log-${this.log.id}`
    },
    created_at() {
      return this.log.created_at * 1000
    },
    time() {
      return moment(this.created_at).format('HH:mm')
    },
    date() {
      return moment(this.created_at).format('MMM DD')
    },
    notifier() {
        const notificator = this.log.notificator;
        return `${this.$localized(notificator.localized_name, notificator.first_name) } ${ this.$localized(notificator.localized_surname, notificator.last_name) }`;
    },
    field() {
      const changes = Object.keys(this.log.changes)
      if (changes.includes('time_start') || changes.includes('time_finish')) {
        return 'time'
      }
      return changes[0]
      /*switch(changes) {
                case 'time_start':
                case 'time_finish':
                    return 'time'
            }*/
    },
    eventName() {
      const name = this.log.event?.name
      return name && `«${name}»`
    },
  },
  methods: {
    readMoreClick(e) {
      if (!this.log.notificator || e.target.closest('.modal-notification')) {
        return
      }
      this.openModal(this.idLog)
      this.readLog({
        params: {
          id: this.log.id,
        },
      })
    },
    handleRemove() {
      this.deleteNotification(this.log.id);
    },
    getHtml(text) {
      if (!text) return ''
      const find = new RegExp(
        '(https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*))'
      )
      return text.replace(find, '<a href="$1" target="_blank">$1</a>')
    },
    ...mapActions('notifications', ['deleteNotification']),
    ...mapMutations(['openModal']),
    ...mapActions('events', ['readLog']),
  },
}
</script>

<style lang="scss">
.notifications-item {
  position: relative;
  padding: 25px 30px;
  word-break: break-word;
  overflow: hidden;
  border-radius: 13px;
  background: #F7F9FB;

  .mobile-time {
    display: none;
    font-weight: bold;
    font-size: 12px;
    line-height: 15px;
    color: $dark;
    margin-top: 21px;
  }

  &:hover {
    box-shadow: 0px 5px 21px 0px #CCD7E630;
    background: #FFFFFF;

    .notifications-item__actions {
      display: flex;
    }
  }

  &__actions {
    position: absolute;
    right: 40px;
    top: 50%;
    transform: translateY(-50%);

    display: none;
    align-items: center;

    svg {
      cursor: pointer;
    }

    > * + * {
      margin-left: 16px;
    }
  }

  .notificator {
    color: $text;
    &__title {
      display: flex;
      align-items: center;

      font-weight: 700;
      font-size: 16px;
      line-height: 117.5%;
      margin: 0;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    &__content {
      font-size: 12px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      max-height: 3em;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: calc(100% - 208px);
    }
  }

  @include mobile {
    padding: 18px 20px;
    .notificator {
      &__content {
        display: none;
      }
    }
  }

  &.notificator {
    cursor: pointer;
  }

  &:hover {
    .date {
      color: $text;
    }
  }

  &__content {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    max-height: 3em;
    overflow: hidden;

    font-weight: 400;
    font-size: 12px;
    line-height: 147.5%;
    @include PC {
      display: none;
    }
  }

  .modal-notification {
    .content {
      width: 572px;
      padding: 36px;
    }

    .log-title {
      position: relative;
      display: flex;
      align-items: center;
      text-align: left;
      margin-bottom: 16px;

      @include PC {
        padding-right: 100px;
      }

      .date {
        position: absolute;
        right: 0;
        width: 110px;
        text-align: right;
        margin: 0;
      }
    }

    button.remove {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(25%, -25%);
    }
  }

  &.notificator {
    padding-right: 50px;

    @include mobile {
      padding: 10px;
    }
  }

  .badge {
    margin-left: 8px;
  }

  .user .action,
  .notificator-title {
    display: -webkit-box;
    margin: 0;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: 2.35em;
    overflow: hidden;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 117.5%;
    color: $text;

    span {
      text-transform: capitalize;
    }
  }

  .user {
    display: flex;
    align-items: center;
    width: calc(100% - 208px);

    @include mobile {
      margin-bottom: 50px;
      width: 100%;
    }

    .avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 35px;
      height: 35px;
      margin-right: 22px;
      border-radius: 10px;

      @include mobile {
        margin-right: 15px;
      }
    }

    .author {
      margin-right: 4px;
    }

    .author + .action span {
      text-transform: lowercase;
    }

    .title {
      display: flex;
      flex-direction: column;
      width: 100% !important;
      //align-items: center;
    }
  }

  .date {
    display: none;
    margin-bottom: 6px;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    color: #ccd7e6;
  }

  .about {
    font-weight: bold;
    font-size: 12px;
    line-height: 145%;
  }

  .time {
    font-weight: 700;
    font-size: 12px;
    line-height: 147.5%;
    letter-spacing: -0.01em;
    color: $dark;
    margin-left: 12px;

    @include mobile {
      position: absolute;
      bottom: 10px;
      right: 10px;
    }
  }

  & + & {
    margin-top: 15px;
  }

  button.read {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }

  .middle {
    position: relative;
    font-size: 12px;
    line-height: 158%;
    color: $dark;
    margin-left: auto;
    padding-left: 14px;
    padding-right: 16px;
    width: 100%;
    max-width: 240px;

    &::before {
      display: inline-block;
      content: ' ';
      position: absolute;
      left: 0;
      width: 1px;
      top: 0;
      bottom: 0;
      background: rgba(180, 187, 198, 0.3);
    }

    span {
      display: inline;
    }

    .badge {
      display: inline-block;
      width: 30px;
      height: 15px;
      line-height: 17px;
      margin-left: 4px;
    }
  }

  @include PC {
    .user {
      margin-bottom: 20px;
    }

    &:not(.large-pc) {
      .date {
        display: block;
      }

      .user {
        margin-bottom: 0;

        .avatar {
          display: none;
        }

        .title {
          font-size: 16px;
        }
      }
    }
  }

  .title {
    .notificator {
    }

    &__main {
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      color: $text;

      > span {
        margin-right: 6px;
      }
    }

    &__main-tag {
      display: inline-block;
      margin-left: 8px;

      @include PC {
        display: none;
      }
    }

    &__header {
      display: flex;
      align-items: flex-start;
    }

    &__sub {
      display: inline-flex;
      margin-top: 1px;
      max-width: 100%;

      .action {
        display: inline-block;
        max-width: 100%;
        min-width: 1px;

        font-weight: 400;
        font-size: 12px;
        line-height: 147.5%;
        text-overflow: ellipsis;
      }
    }
  }

  @include mobile {
    .title__sub {
      display: none;
    }
  }

  .middle {
    margin-top: 16px;
    margin-left: 0;
  }

  .right {
    display: none;
  }

  &.large-pc {
    button.read {
      position: static;
      transform: unset;
      margin-right: 26px;
      background: rgba($lightGray, 0.3);
      color: $dark;

      &:hover {
        background: $primary;
        color: white;
      }
    }

    .user {
      .title {
        width: calc(100% - 30px - 22px);
        min-width: 1px;
      }
    }

    @include PC {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 40px;

      .notificator .hide-mobile {
        display: none;
      }

      .right {
        flex: 0 0 auto;
        @include flexCenter;
      }

      .title {
        min-width: 1px;
      }

      .middle {
        margin-top: 0;
      }

      .user {
        margin: 0;
        padding-right: 20px;

        .avatar {
          margin-right: 22px;

          width: 35px;
          height: 35px;
        }

        .title {
          width: auto;
        }

        .author {
          font-size: 14px;
          line-height: 20px;
        }
      }

      .about {
        font-size: 14px;
        line-height: 20px;
        max-width: 300px;
      }
    }
  }

  &.is-read {
    background: none;
    .user {
      .avatar {
        background-color: $primary;

        img {
          filter: brightness(2);
        }
      }
    }
  }

  &--in-modal {
    display: block !important;
    padding: 14px 24px;

    .user {
      width: calc(100% - 18px) !important;
    }

    .time {
      display: none;
    }

    .mobile-time {
      display: block;
    }

    .notifications-item__actions {
      right: 24px;
      top: 12px;
      bottom: 12px;
      transform: none;

      flex-direction: column-reverse;
      justify-content: space-between;
      align-items: flex-end;
    }
  }
}
</style>
